import React from 'react';
import ToolTip from 'components/common/tooltip';
import CircleIcon from '@mui/icons-material/Circle';
import clsx from 'clsx';
import { isEmptyString } from 'utils/helper';
import zipObject from 'lodash/zipObject';

const valueOptions = ['off', 'error', 'pending', 'success'] as const;
type ValueOption = typeof valueOptions[number];

const statusColors: Readonly<Record<ValueOption, string>> = Object.freeze(zipObject(
  valueOptions,
  ['text-gray-600', 'text-red-600', 'text-orange-400', 'text-emerald-700'],
) as Record<ValueOption, string>);

type Props = {
  title?: string;
  wrapperClass?: string;
  text?: string;
  type?: typeof valueOptions[number];
  hasIcon?: boolean;
  hide?: boolean;
}

export default function StatusTag({
  title,
  text = '',
  type = 'success',
  hasIcon = true,
  wrapperClass,
  hide,
}: Props) {
  const color = statusColors[type];
  const wrapperStyle = clsx(
    '!text-xs rounded px-2.5 py-0.5 font-medium bg-gray-100 border !border-gray-300',
    color,
    wrapperClass,
  );
  const iconClass = clsx(
    '!text-xs mr-1',
    color,
  );

  return (
    <ToolTip title={title} hide={isEmptyString(title) || hide}>
      <span className={wrapperStyle}>
        {hasIcon && <CircleIcon className={iconClass} />}
        {text}
      </span>
    </ToolTip>
  );
}
